module.exports = __webpack_public_path__ + "static/media/JP_RS_EYELASHES02.292df036.jpg";